import { render, staticRenderFns } from "./RealtimeClock.vue?vue&type=template&id=862783d2&"
import script from "./RealtimeClock.vue?vue&type=script&lang=js&"
export * from "./RealtimeClock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports